import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import type { SortOption } from '../../@types/ElasticSearchResponse';
import { Form, FormGroup } from '../../styled-components/components/Form';
import Modal from '../../styled-components/components/Modal';
import SortOptionComponent from './sort-option';

interface SortOptionsModalProps {
  sortOptions: SortOption[];
  onClose: () => void;
  onApplySort: (query: string) => void;
}

const SortOptionsModal = ({ sortOptions, onClose, onApplySort }: SortOptionsModalProps) => {
  const { t } = useTranslation(['common', 'search']);
  const [options, setOptions] = useState<SortOption[]>([]);

  useEffect(() => {
    if (sortOptions.length) setOptions(sortOptions);
  }, [sortOptions]);

  return (
    <Modal heading={t('Sort', { ns: 'common' })} onClose={onClose}>
      <Form>
        {options.map((sortOption) => (
          <FormGroup key={sortOption.query}>
            <SortOptionComponent
              sortOption={sortOption}
              onClick={onApplySort}
              disabled={!sortOptions.length}
            />
          </FormGroup>
        ))}
      </Form>
    </Modal>
  );
};

export default SortOptionsModal;
